import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Combines class names with conditional logic (clsx)
 * and resolves TailwindCSS class conflicts (twMerge).
 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(...inputs));
}
